var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9055 0.00695855C20.8118 -0.0024009 20.7174 -0.0024009 20.6237 0.00695855H1.37365C1.25028 0.00880117 1.12772 0.0267321 1.00928 0.0602685L10.9437 9.6494L20.9055 0.00695855Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9234 0.933167L11.9134 10.5956C11.6557 10.8438 11.3072 10.9832 10.944 10.9832C10.5807 10.9832 10.2322 10.8438 9.97461 10.5956L0.0539844 1.00647C0.0234865 1.11511 0.00731597 1.22707 0.00585938 1.33966V14.6672C0.00585938 15.0206 0.150725 15.3596 0.408588 15.6095C0.66645 15.8595 1.01619 15.9999 1.38086 15.9999H20.6309C20.9955 15.9999 21.3453 15.8595 21.6031 15.6095C21.861 15.3596 22.0059 15.0206 22.0059 14.6672V1.33966C22.0004 1.20082 21.9726 1.06367 21.9234 0.933167ZM2.32273 14.6672H1.36711V13.7142L6.36523 8.90967L7.33461 9.84926L2.32273 14.6672ZM20.6171 14.6672H19.6546L14.6427 9.84926L15.6121 8.90967L20.6102 13.7142L20.6171 14.6672Z",
    fill: "#757A88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackMail);
export default __webpack_public_path__ + "static/media/feedback_mail.88c53325357f135a4b8f21aaaa9c0e8e.svg";
export { ForwardRef as ReactComponent };